import {Injectable} from '@angular/core';
import {ComponentBase} from '../../../component-base';
import {IMouseDown, IMouseMove, IMouseRelease, IDoubleClick} from '../Interfaces';
import {Circle} from '../object3D';
import {DrawingsHolderService} from '../drawings-holder.service';
import {PositionCalculatorService} from '../position-calculator.service';
import { SelectComponent } from '.';

@Injectable()
export class DrawCircleComponent extends ComponentBase implements IMouseDown, IMouseMove, IMouseRelease, IDoubleClick {
  added: boolean = false;
  dblclick(e: MouseEvent): boolean {
    
    this.circle = undefined;
    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  
  }

  private circle: Circle | undefined;
  private firstPoint;

  constructor(
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
  }

  mouseDown(e: MouseEvent): boolean {
    // const point = this.positionCalculator.calculate(e);
    // const circle = new Circle();
    // circle.position.copy(point);
    // this.circle = circle;
    // this.firstPoint = point;
    return true;
  }

  mouseMove(e: MouseEvent): boolean {
    if (this.circle) {
      const point = this.positionCalculator.calculate(e);
      if (this.firstPoint.distanceTo(point) > 4) {
      const radius = this.firstPoint.distanceTo(point);
      this.circle.update(radius, radius);
      if (this.added) {

      } else {
        this.added = true;
        this.drawings.canvas.add(this.circle);
      }
      }
      return true;
    }
    return false;
  }

  mouseUp(e: MouseEvent): boolean {
    if (this.firstPoint) {
      this.added = false;
      this.firstPoint = null;
      return false;
    } else if (this.circle) {
      this.circle = null;
      return false;
    } else {
      const point = this.positionCalculator.calculate(e);
      const circle = new Circle();
      circle.position.copy(point);
      this.circle = circle;
      this.firstPoint = point;
      return true;
    }
    // return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawCircleComponent.ts